import React, { Component, PropTypes } from 'react';
import { lang } from '../../strings';

export default class VerifyContactDetailsDialog extends Component {
  constructor(props) {
    super(props);

    this.state = this.makeInitialState(props);
  }

  makeInitialState(props) {
    let { customer } = props;
    let { contactName, emailAddress, phoneNumber } = customer.toJS();

    return {
      confirmed: false,
      contactName: contactName,
      emailAddress: emailAddress,
      phoneNumber: phoneNumber,
    };
  }

  render() {
    let { confirmed, contactName, emailAddress, phoneNumber } = this.state;
    let { networkProgress } = this.props;

    let buttonText = networkProgress
      ? lang.customer.verify.loading
      : lang.customer.verify.button;

    return (
      <div className='c-verify-details mp-popup-container'>
        <div className='mp-popup-content'>
          <h2 className='h5 color-dark-blue'>{lang.customer.verify.title}</h2>
          <p className='no-margin'>{lang.customer.verify.intro}</p>
          <form onSubmit={this.onSubmit} className='sqs-block-form'>
            <div className='grid-y'>
              <div className='form-item'>
                <label>{lang.customer.contactName}</label>
                <input
                  type='text'
                  name='contactName'
                  maxLength='27'
                  onChange={this.handleContactName}
                  value={contactName}
                />
              </div>
              <div className='form-item'>
                <label>{lang.customer.emailAddress}</label>
                <input
                  type='text'
                  name='emailAddress'
                  maxLength='35'
                  onChange={this.handleEmailAddress}
                  value={emailAddress}
                />
              </div>
              <div className='form-item'>
                <label>{lang.customer.phoneNumber}</label>
                <input
                  type='text'
                  name='phoneNumber'
                  maxLength='18'
                  onChange={this.handlePhoneNumber}
                  value={phoneNumber}
                />
              </div>
              <div className='form-item'>
                <label>
                  <input
                    type='checkbox'
                    value={confirmed}
                    onChange={this.handleConfirmed}
                  />{' '}
                  {lang.customer.verify.confirm}
                </label>
              </div>
              <input
                type='submit'
                disabled={this.isDisabled()}
                className='sqs-editable-button'
                value={buttonText}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }

  handleContactName = ev => {
    this.setState({ contactName: ev.target.value });
  };

  handleEmailAddress = ev => {
    this.setState({ emailAddress: ev.target.value });
  };

  handlePhoneNumber = ev => {
    this.setState({ phoneNumber: ev.target.value });
  };

  isDisabled() {
    let { contactName, emailAddress, phoneNumber, confirmed } = this.state;
    let { networkProgress } = this.props;
    let enabled =
      confirmed &&
      contactName &&
      emailAddress &&
      phoneNumber &&
      !networkProgress;

    return !enabled;
  }

  handleConfirmed = ev => {
    this.setState({ confirmed: ev.target.checked });
  };

  onSubmit = ev => {
    ev.preventDefault();
    let { contactName, emailAddress, phoneNumber } = this.state;
    let data = {
      contactName: contactName,
      emailAddress: emailAddress,
      phoneNumber: phoneNumber,
    };
    this.props.onSubmit(data);
  };
}

VerifyContactDetailsDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired,
};
